/*
 * @Author: Ryan
 * @Date: 2026-01-21
 * @Description: UGC Generator 配置文件
 */

import { AIFunction } from '@/utils/const';
import { PageTabParam } from '@/utils/router';

/**
 * 生成器选项类型
 */
export interface GeneratorOption {
  key: string;
  label: string;
  route: string;
  /** 文生场景的 Tab Key */
  textTabKey?: string;
  /** 图生场景的 Tab Key */
  imageTabKey?: string;
  /** 卡片封面图（占位） */
  coverImage?: string;
}

/**
 * 生成器选项配置
 * 所有选项都支持上传图片，根据是否上传图片决定进入哪个 Tab
 */
export const generatorOptions: GeneratorOption[] = [
  {
    key: 'ugc-video-ads',
    label: 'UGC Video Ads',
    route: '/ai-video-generator',
    textTabKey: PageTabParam.TEXT_TO_VIDEO,
    imageTabKey: PageTabParam.IMAGE_TO_VIDEO,
    coverImage: '/images/ugc-generator/ugc-video-cover.svg',
  },
  {
    key: 'video-from-product-image',
    label: 'Video from Product Image',
    route: '/ai-product-avatar',
    imageTabKey: 'product',
    coverImage: '/images/ugc-generator/product-photo-cover.svg',
  },
  {
    key: 'video-from-avatar-image',
    label: 'Video from Avatar Image',
    route: '/ai-product-avatar',
    imageTabKey: 'avatar',
    coverImage: '/images/ugc-generator/product-avatar-cover.svg',
  },
  {
    key: 'generate-image',
    label: 'Generate Image',
    route: '/ai-image-generator',
    textTabKey: PageTabParam.TEXT_TO_IMAGE,
    imageTabKey: PageTabParam.IMAGE_TO_IMAGE,
    coverImage: '/images/ugc-generator/create-image-cover.svg',
  },
];

/**
 * 通用上传配置
 */
export const ugcUploadConfig = {
  accept: '.jpg,.png,.jpeg',
  maxCount: 1,
  maxSize: 10 * 1024 * 1024,
  minResolution: '300*300',
  maxResolution: '5000*5000',
};

/**
 * 根据目标类型获取上传配置
 */
export const getUploadConfigByType = (targetType: string) => {
  return {
    ...ugcUploadConfig,
    feature:
      targetType === 'product-photo-suite' || targetType === 'ai-avatar'
        ? AIFunction.ProductAvatar
        : targetType.includes('video')
          ? AIFunction.Image2Video
          : AIFunction.Image2Image,
  };
};
